import { css } from '@emotion/core';
import { media, variables, aNormalize as aNormalizeFeBrary } from '@domain-group/fe-brary';
var font = variables.font;
var buildStyle = function buildStyle() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    size = _ref.size,
    lineHeight = _ref.lineHeight,
    _ref$weight = _ref.weight,
    weight = _ref$weight === void 0 ? 'normal' : _ref$weight,
    _ref$family = _ref.family,
    family = _ref$family === void 0 ? font.bodyFontFamily : _ref$family,
    transform = _ref.transform,
    spacing = _ref.spacing,
    margin = _ref.margin,
    color = _ref.color,
    strongStyle = _ref.strongStyle,
    aStyle = _ref.aStyle,
    supStyle = _ref.supStyle;
  return /*#__PURE__*/css("font-family:", family, ";font-style:normal;font-weight:", weight, ";font-size:", size, ";line-height:", lineHeight, ";margin:", margin, ";", color && "color: ".concat(color, ";"), " ", transform && "text-transform: ".concat(transform, ";"), " ", spacing && "letter-spacing: ".concat(spacing, ";"), " ", strongStyle && /*#__PURE__*/css("strong{", strongStyle, "}"), " ", aStyle && /*#__PURE__*/css("a:link,a:visited{", aNormalizeFeBrary, " ", aStyle, "}"), " ", supStyle && /*#__PURE__*/css("sup{", supStyle, "}"));
};
var displayLStrongStyle = /*#__PURE__*/css("font-family:", font.boldHeadingFontFamily, ";");
export var desktopDisplayL = buildStyle({
  family: font.headingFontFamily,
  size: '40px',
  lineHeight: '52px',
  margin: '0 0 8px 0',
  strongStyle: displayLStrongStyle
});
export var mobileDisplayL = buildStyle({
  family: font.headingFontFamily,
  size: '36px',
  lineHeight: '40px',
  margin: '0 0 8px 0',
  strongStyle: displayLStrongStyle
});
export var displayL = /*#__PURE__*/css(mobileDisplayL, ";", media('>=tablet'), "{", desktopDisplayL, "}");
export var desktopDisplayM = buildStyle({
  family: font.headingFontFamily,
  size: '32px',
  lineHeight: '36px',
  weight: 600
});
export var mobileDisplayM = buildStyle({
  family: font.headingFontFamily,
  size: '28px',
  lineHeight: '32px',
  weight: 600
});
export var displayM = /*#__PURE__*/css(mobileDisplayM, ";", media('>=tablet'), "{", desktopDisplayM, "}");
export var desktopDisplayS = buildStyle({
  family: font.headingFontFamily,
  size: '20px',
  lineHeight: '28px',
  weight: 600
});
export var mobileDisplayS = buildStyle({
  family: font.headingFontFamily,
  size: '20px',
  lineHeight: '24px',
  weight: 600
});
export var displayS = /*#__PURE__*/css(mobileDisplayS, ";", media('>=tablet'), "{", desktopDisplayS, "}");
var linkUnderline = _ref2 => {
  var colour = _ref2.colour;
  return /*#__PURE__*/css("border-bottom:2px dotted ", colour, ";padding-bottom:1px;");
};
var displayBodyAStyle = /*#__PURE__*/css("position:relative;cursor:pointer;transition-property:color,border-bottom;transition-duration:0.3s;transition-timing-function:ease;", linkUnderline({
  colour: variables.colour.allhomesRed700
}), ":hover{color:", variables.colour.allhomesRed700, ";}");
var displayBodyStrongStyle = /*#__PURE__*/css("font-family:", font.boldHeadingFontFamily, ";");
var displayBodySupStyle = {
  name: "dida9t",
  styles: "font-size:70%;font-family:inherit;vertical-align:top;display:inline-block;transform:translateY(-30%);margin-left:0.1em;"
};
export var displayBody = buildStyle({
  family: font.headingFontFamily,
  size: '18px',
  lineHeight: '24px',
  strongStyle: displayBodyStrongStyle,
  aStyle: displayBodyAStyle,
  supStyle: displayBodySupStyle
});
var aLightStyle = /*#__PURE__*/css("color:", variables.colour.white, ";:after{border-color:", variables.colour.white, ";}:hover{color:", variables.colour.allhomesRed100, ";:after{border-color:", variables.colour.allhomesRed100, ";}}");
export var displayLight = buildStyle({
  family: font.headingFontFamily,
  color: variables.colour.white,
  aStyle: aLightStyle
});
export var desktopHeadingXL = buildStyle({
  family: font.headingFontFamily,
  size: '28px',
  lineHeight: '32px',
  weight: 600
});
export var mobileHeadingXL = buildStyle({
  family: font.headingFontFamily,
  size: '24px',
  lineHeight: '28px',
  weight: 600
});
export var headingXL = /*#__PURE__*/css(mobileHeadingXL, ";", media('>=tablet'), "{", desktopHeadingXL, "}");
export var desktopHeadingL = buildStyle({
  family: font.headingFontFamily,
  size: '24px',
  lineHeight: '28px',
  weight: 600
});
export var mobileHeadingL = buildStyle({
  family: font.headingFontFamily,
  size: '22px',
  lineHeight: '28px',
  weight: 600
});
export var headingL = /*#__PURE__*/css(mobileHeadingL, ";", media('>=tablet'), "{", desktopHeadingL, "}");
export var desktopHeadingM = buildStyle({
  family: font.headingFontFamily,
  size: '18px',
  lineHeight: '24px',
  weight: 600
});
export var mobileHeadingM = desktopHeadingM;
export var headingM = /*#__PURE__*/css(mobileHeadingM);
export var desktopHeadingCaps = buildStyle({
  family: font.headingFontFamily,
  size: '14px',
  lineHeight: '18px',
  weight: 600,
  transform: 'uppercase'
});
export var mobileHeadingCaps = buildStyle({
  family: font.headingFontFamily,
  size: '14px',
  lineHeight: '18px',
  weight: 600,
  transform: 'uppercase'
});
export var headingCaps = /*#__PURE__*/css(mobileHeadingCaps, ";", media('>=tablet'), "{", desktopHeadingCaps, "}");
export var desktopHeadingS = buildStyle({
  family: font.bodyFontFamily,
  size: '18px',
  lineHeight: '24px',
  weight: 600,
  spacing: '0.1px'
});
export var mobileHeadingS = desktopHeadingS;
export var headingS = /*#__PURE__*/css(mobileHeadingS, ";");
export var bodyBold = buildStyle({
  size: '16px',
  lineHeight: '20px',
  weight: 600
});
var bodyStrongStyle = {
  name: "35ezg3",
  styles: "font-weight:600;"
};
var bodyAStyle = /*#__PURE__*/css("position:relative;cursor:pointer;transition-property:color,border-bottom;transition-duration:0.3s;transition-timing-function:ease;", linkUnderline({
  colour: variables.colour.allhomesRed700
}), ":hover{color:", variables.colour.allhomesRed700, ";}");
var bodySupStyle = {
  name: "3b14je",
  styles: "font-size:70%;font-family:inherit;vertical-align:super;margin-left:0.2em;"
};
export var body = buildStyle({
  size: '16px',
  lineHeight: '20px',
  aStyle: bodyAStyle,
  strongStyle: bodyStrongStyle,
  supStyle: bodySupStyle
});
export var bodyNoLinks = buildStyle({
  size: '16px',
  lineHeight: '20px',
  strongStyle: bodyStrongStyle,
  supStyle: bodySupStyle
});
export var bodyLong = buildStyle({
  size: '16px',
  lineHeight: '24px',
  margin: '0 0 12px 0',
  aStyle: bodyAStyle,
  strongStyle: bodyStrongStyle,
  supStyle: bodySupStyle
});
export var bodyLongNoLinks = buildStyle({
  size: '16px',
  lineHeight: '24px',
  margin: '0 0 12px 0',
  strongStyle: bodyStrongStyle,
  supStyle: bodySupStyle
});
export var bodyLongBold = buildStyle({
  size: '16px',
  lineHeight: '24px',
  weight: 600,
  margin: '0 0 12px 0'
});
export var bodySmall = buildStyle({
  size: '14px',
  lineHeight: '20px'
});
export var bodySmallBold = buildStyle({
  size: '14px',
  lineHeight: '20px',
  weight: 600
});
var buttonLink = offset => /*#__PURE__*/css("display:inline-block;padding:0;color:inherit;font:inherit;border:0;background:none;cursor:pointer;white-space:nowrap;:after{content:'';display:block;position:absolute;width:100%;bottom:", offset, "px;height:10px;transition:all 0.3s ease;", linkUnderline({
  colour: variables.colour.allhomesRed700
}), "}");
export var displayBodyButtonLink = /*#__PURE__*/css(displayBodyAStyle, " ", buttonLink(-1));
export var bodyButtonLink = /*#__PURE__*/css(bodyAStyle, " ", buttonLink(-3));
export var bodyLongButtonLink = /*#__PURE__*/css(bodyAStyle, " ", buttonLink(-1));